// extracted by mini-css-extract-plugin
export default {"face-tracking__loader":"styles_face-tracking__loader__4MqLd","face-tracking__canvas":"styles_face-tracking__canvas__KObnF"};